module.exports = __webpack_public_path__ + "static/media/BOLTON_APP_LOGO.3b9853a1.png";